import {UI} from "../../../stem-core/ui/UIBase";
import {styleRule, StyleSheet} from "../../../stem-core/ui/Style";
import {registerStyle} from "../../../stem-core/ui/style/Theme";

import {Messages} from "../../Messages";
import {authService, AuthService} from "../../../client/connection/services/AuthService";
import {startDashboardFlow} from "../flows/FlowEntrypoint.js";
import {PanelLink} from "./PanelLink.jsx";
import {Flow} from "../flows/Flow.js";
import {handleActionButtonClicked} from "./ActionButton.jsx";


class LoginFooterStyle extends StyleSheet {
    @styleRule
    container = {
        color: this.themeProps.TEXT_SECONDARY_COLOR,
        textAlign: "center",
        width: "100%",
        margin: "18px 0px",
        fontSize: this.themeProps.FONT_SIZE_LARGE
    };
}

@registerStyle(LoginFooterStyle)
export class LoginFooter extends UI.Element {
    getDefaultOptions() {
        return {
            label: "",
            linkLabel: Messages.logIn,
        };
    }

    render() {
        const {label, linkLabel} = this.options;

        return [
            label || Messages.alreadyHaveAnAccount,
            " ",
            <PanelLink
                value={linkLabel}
                onClick={(e) => handleActionButtonClicked(Flow.auth, e)}
            />,
        ];
    }

    onMount() {
        super.onMount();
        this.attachListener(authService, AuthService.EventTypes.AUTHENTICATION_CHANGE, () => this.redraw());
    }
}

// TODO @cleanup probably merge with the class above, or be included in.
export class PromptManageAccountButton extends PanelLink {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            label: Messages.manageMyAccount,
            onClick: () => startDashboardFlow(),
        };
    }
}
